import axios from 'axios';

const csrfToken = document.querySelector('[name="csrf-token"]') || document.head.querySelector('meta[name="csrf-token"]') || { content: 'no-csrf-token' };

const transport = axios.create({
  withCredentials: true,
  credentials: 'include',
  headers: {
    common: {
      'X-CSRF-Token': csrfToken.content,
    },
  },
});

const url = window.location.href.includes('localhost') ? 'http://localhost:9112' : 'https://billing-api.superagi.com';
let BASE_PATH = process.env.NODE_ENV === 'development' ? url : 'https://billing-api.superagi.com';
if (process.env.NODE_ENV === 'staging') {
  BASE_PATH = 'https://billing-api-staging.superagi.com';
}

const salesUrl = 'http://localhost:3000';
let SALES_PATH = process.env.NODE_ENV === 'development' ? salesUrl : 'https://sales.superagi.com';
if (process.env.NODE_ENV === 'staging') {
  SALES_PATH = 'https://sales-staging.superagi.com';
}

export default {
  getBaseSalesPath() {
    return SALES_PATH;
  },

  async getOrCreateAccount() {
    try {
      const response = await transport.get(`${BASE_PATH}/api/v4/dashboard/account`);
      return response.data;
    } catch (error) {
      console.error('Error fetching V4 billing account:', error);
      return null;
    }
  },

  async onboard() {
    try {
      const response = await transport.post(`${BASE_PATH}/api/v4/dashboard/onboard`);
      return response.data;
    } catch (error) {
      console.error('Error onboarding V4 billing account:', error);
      return null;
    }
  },

  async buyCredits(creditCount, uiMode = 'embedded', returnUrl = '', isRecurring = false) {
    try {
      const response = await transport.post(`${BASE_PATH}/api/v4/dashboard/buy_credits`, {
        credit_count: creditCount,
        ui_mode: uiMode,
        return_url: returnUrl,
        is_recurring: isRecurring,
      });
      return response.data;
    } catch (error) {
      console.error('Error creating V4 checkout session:', error);
      return null;
    }
  },

  async addCreditsOneTime(creditCount, uiMode = 'embedded', returnUrl = '') {
    try {
      const response = await transport.post(`${BASE_PATH}/api/v4/dashboard/add_credits`, {
        credit_count: creditCount,
        ui_mode: uiMode,
        return_url: returnUrl,
      });
      return response.data;
    } catch (error) {
      console.error('Error creating V4 one-time checkout session:', error);
      return null;
    }
  },

  async getCustomerPortal() {
    try {
      const response = await transport.get(`${BASE_PATH}/api/v4/dashboard/customer_portal`);
      return response.data;
    } catch (error) {
      console.error('Error fetching V4 customer portal:', error);
      return null;
    }
  },

  async updateAutoRecharge(creditCount) {
    try {
      const response = await transport.post(`${BASE_PATH}/api/v4/dashboard/update_auto_recharge`, {
        credit_count: creditCount,
      });
      return response.data;
    } catch (error) {
      console.error('Error updating auto-recharge:', error);
      return error.response?.data || null;
    }
  },

  async cancelAutoRecharge() {
    try {
      const response = await transport.post(`${BASE_PATH}/api/v4/dashboard/cancel_auto_recharge`);
      return response.data;
    } catch (error) {
      console.error('Error cancelling auto-recharge:', error);
      return null;
    }
  },

  async verifyRazorpayPayment(paymentData) {
    try {
      const response = await transport.post(`${BASE_PATH}/api/v4/dashboard/verify_razorpay_payment`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error verifying Razorpay payment:', error);
      return null;
    }
  },

  async activateRazorpaySubscription(paymentData) {
    try {
      const response = await transport.post(`${BASE_PATH}/api/v4/dashboard/activate_razorpay_subscription`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error activating Razorpay subscription:', error);
      return error.response?.data || null;
    }
  },
};
